module.exports = __webpack_public_path__ + "static/media/right.658f9a4d.svg";